import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsPropertyOwnerAnotherIndividual,
} from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';

class PropertyOwnerLastNameRuleset implements Ruleset {
  private index: number;

  public setIndex(index: number): PropertyOwnerLastNameRuleset {
    this.index = index;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isLeased = IsPropertyLeased.evaluate(data);
    const isAnotherIndividual = IsPropertyOwnerAnotherIndividual.setIndex(
      this.index
    ).evaluate(data);
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);

    return isLeased && isAnotherIndividual && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyOwnerLastNameRuleset();
